import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  NgModule,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatCardModule } from "@angular/material/card";
import { HighchartsChartModule } from "highcharts-angular";
import { ApplicationDataService } from "../../core/services/application-data.service";
import HC_Exporting from "highcharts/modules/exporting";
import HC_ExportingOffline from "highcharts/modules/offline-exporting";
import HC_ExportData from "highcharts/modules/export-data";
import HC_More from "highcharts/highcharts-more";
import { DashboartChartGenderModel } from "../../core/models/dashboard-cart-gender.model";
import Drilldown from "highcharts/modules/drilldown";
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  AbstractControl,
} from "@angular/forms";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { MatOptionModule } from "@angular/material/core";
import * as Highcharts from "highcharts";
import HighchartsAccessibility from "highcharts/modules/accessibility";

HighchartsAccessibility(Highcharts);
import theme from "highcharts/themes/brand-light";

import { TranslateModule } from "@ngx-translate/core";
import { MatInputModule } from "@angular/material/input";
import { AuthenticationService } from "../../core/services/authentication.service";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { TokenStorageService } from "../../core/services/token-storage.service";
import { MatDialog } from "@angular/material/dialog";
theme(Highcharts);
Drilldown(Highcharts);
const today = new Date();
const month = today.getMonth();
const year = today.getFullYear();

type chartType = "bar" | "line" | "column" | "pie" | "area" | "scatter";
HC_Exporting(Highcharts);
HC_ExportingOffline(Highcharts);
HC_ExportData(Highcharts);
HC_More(Highcharts);

@Component({
  selector: "app-dashboard",
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatSelectModule,
    MatOptionModule,
    HighchartsChartModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: "./dashboard.component.html",
  providers: [provideNativeDateAdapter()],
  styleUrl: "./dashboard.component.css",
})
export class DashboardComponent implements OnInit {
  form: FormGroup;
  chart1: typeof Highcharts = Highcharts;
  chart2: typeof Highcharts = Highcharts;
  chart3: typeof Highcharts = Highcharts;
  chart4: typeof Highcharts = Highcharts;

  displayedColumns: string[] = ["name"];
  displayColumns: string[] = [...this.displayedColumns];
  chartTypes: chartType[] = ["bar", "column", "line", "pie", "area", "scatter"];
  selectedChartType: chartType = "bar";
  complaintProcessList: any[] = [];
  selectedColumns: { [key: string]: boolean } = {};
  originalComplaintProcessList: any[] = [];
  allComplaints: any[] = [];
  userId: string | null = null;

  assignTo: number | string = "";
  assignToUserName: string = "";
  assignRole: string = "";
  assignRoleAdmin: boolean = false;
  usersList: any[] = [];
  usersListOriginal: any[] = [];
  userRole: string;

  @ViewChild("searchCurrentProcess")
  searchCurrentProcess: ElementRef<HTMLInputElement>;

  onChartTypeChange(event: any) {
    this.selectedChartType = event.target.value;
    this.updateCharts();
  }

  updateCharts() {
    const isPieChart = this.selectedChartType === "pie";
    const categoryData = this.totalCountofComplaintbCategoryChartData || [];
    const divisionData = this.totalCountofComplaintbyDivisionChartData || [];

    // If pie chart is selected, keep chart1 and chart2 as bar charts
    if (isPieChart) {
      this.chart1Options.chart!.type = 'bar';
      this.chart2Options.chart!.type = 'bar';
    } else {
      this.chart1Options.chart!.type = this.selectedChartType;
      this.chart2Options.chart!.type = this.selectedChartType;
    }
    this.chart3Options.chart!.type = this.selectedChartType;
    this.chart4Options.chart!.type = this.selectedChartType;

    // Update chart1 and chart2 with proper spacing for external totals

    // For chart1 (Complaint Status): if pie is selected, keep as bar chart
    this.chart1Options.series = isPieChart
      ? [
        {
          type: "bar",
          name: "Male",
          data: this.totalCountofComplaintbyStatusChartDataMale,
        },
        {
          type: "bar",
          name: "Female",
          data: this.totalCountofComplaintbyStatusChartDataFemale,
          color: "#f79bba",
        },
        {
          type: "bar",
          name: "Transgender Person",
          data: this.totalCountofComplaintbyStatusChartDataOthers,
        },
      ]
      : [
        {
          type: this.selectedChartType,
          name: "Male",
          data: this.totalCountofComplaintbyStatusChartDataMale,
        },
        {
          type: this.selectedChartType,
          name: "Female",
          data: this.totalCountofComplaintbyStatusChartDataFemale,
          color: "#f79bba",
        },
        {
          type: this.selectedChartType,
          name: "Transgender Person",
          data: this.totalCountofComplaintbyStatusChartDataOthers,
        },
      ];

    // For chart2 (Appeal Status): if pie is selected, keep as bar chart
    this.chart2Options.series = isPieChart
      ? [
        {
          type: "bar",
          name: "Male",
          data: this.totalCountOfComplaintsAppealStatusDataMale,
        },
        {
          type: "bar",
          name: "Female",
          data: this.totalCountOfComplaintsAppealStatusDataFemale,
          color: "#f79bba",
        },
        {
          type: "bar",
          name: "Transgender Person",
          data: this.totalCountOfComplaintsAppealStatusDataOthers,
        },
      ]
      : [
        {
          type: this.selectedChartType,
          name: "Male",
          data: this.totalCountOfComplaintsAppealStatusDataMale,
        },
        {
          type: this.selectedChartType,
          name: "Female",
          data: this.totalCountOfComplaintsAppealStatusDataFemale,
          color: "#f79bba",
        },
        {
          type: this.selectedChartType,
          name: "Transgender Person",
          data: this.totalCountOfComplaintsAppealStatusDataOthers,
        },
      ];

    this.chart3Options.series = isPieChart
      ? [
        {
          type: this.selectedChartType,
          data: categoryData,
          name: "Category",
          showInLegend: true,
        },
      ]
      : [
        {
          type: this.selectedChartType,
          data: categoryData,
          name: "Category",
        },
      ];

    this.chart4Options.series = isPieChart
      ? [
        {
          type: this.selectedChartType,
          name: "Division",
          data: divisionData,
          showInLegend: true,
        },
      ]
      : [
        {
          type: this.selectedChartType,
          name: "Division",
          data: divisionData,
        },
      ];

    this.updateFlag = true;
    this.updateFlag3 = true;
    this.updateFlag4 = true;
  }

  chart1Options: Highcharts.Options = {
    chart: {
      type: 'bar',
      // height: 400,
      animation: false,
      spacingRight: 10 // Extra space for total labels
    },

    title: {
      text: 'Complaint Status',
      align: 'left'
    },

    xAxis: {
      categories: [],
      title: {
        text: null
      },
      labels: {
        overflow: 'justify'
      },
      gridLineWidth: 0
    },

    yAxis: {
      min: 0,
      title: {
        text: '',
        align: 'high'
      },
      labels: {
        overflow: 'justify'
      },
      gridLineWidth: 1,
      gridLineColor: '#e0e0e0',
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: 'bold',
          color: '#46465c',
          fontSize: '12px'
        },
        formatter: function (): string {
          return `${this.total}`;
        }
      }
    },

    legend: {
      reversed: true,
      align: 'center',
      verticalAlign: 'bottom'
    },

    plotOptions: {
      series: {
        stacking: 'normal',
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '11px',
            fontWeight: 'bold',
            color: '#000000',
            textOutline: '1px contrast'
          },
          formatter: function (): string | null {
            if (this.y && this.y > 0) {
              return `${this.y}`;
            }
            return null;
          }
        },
        cursor: 'pointer',
        point: {
          events: {
            click: this.onComplaintStatusBarClick.bind(this)
          }
        }
      }
    },

    tooltip: {
      useHTML: true,
      formatter: function (): string {
        return `
          <b>${this.series.name}</b><br>
          <span>${this.key || ""}</span>: ${this.y}
        `;
      }
    },

    credits: {
      enabled: false
    },

    series: [
      {
        type: "bar",
        name: "Male",
        data: [],
      },
      {
        type: "bar",
        name: "Female",
        data: [],
      },
      {
        type: "bar",
        name: "Transgender Person",
        data: [],
      },
    ]
  };

  chart2Options: Highcharts.Options = {
    chart: {
      type: 'bar',
      //  height: 400,
      animation: false,
      spacingRight: 10 // Extra space for total labels
    },

    title: {
      text: 'Appeal Status',
      align: 'left'
    },

    xAxis: {
      categories: [],
      title: {
        text: null
      },
      labels: {
        overflow: 'justify'
      },
      gridLineWidth: 0
    },

    yAxis: {
      min: 0,
      title: {
        text: '',
        align: 'high'
      },
      labels: {
        overflow: 'justify'
      },
      gridLineWidth: 1,
      gridLineColor: '#e0e0e0',
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: 'bold',
          color: '#46465c',
          fontSize: '12px'
        },
        formatter: function (): string {
          return `${this.total}`;
        }
      }
    },

    legend: {
      reversed: true,
      align: 'center',
      verticalAlign: 'bottom'
    },

    plotOptions: {
      series: {
        stacking: 'normal',
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '11px',
            fontWeight: 'bold',
            color: '#000000',
            textOutline: '1px contrast'
          },
          formatter: function (): string | null {
            if (this.y && this.y > 0) {
              return `${this.y}`;
            }
            return null;
          }
        },
        cursor: 'pointer',
        point: {
          events: {
            click: this.onAppealStatusBarClick.bind(this)
          }
        }
      }
    },

    tooltip: {
      useHTML: true,
      formatter: function (): string {
        return `
          <b>${this.series.name}</b><br>
          <span>${this.key || ""}</span>: ${this.y}
        `;
      }
    },

    credits: {
      enabled: false
    },

    series: [
      {
        type: "bar",
        name: "Male",
        data: [],
      },
      {
        type: "bar",
        name: "Female",
        data: [],
      },
      {
        type: "bar",
        name: "Transgender Person",
        data: [],
      },
    ]
  };

  chart3Options: Highcharts.Options = {
    chart: {
      type: "bar",
    },
    title: {
      text: "Complainant Categories",
      align: "left",
    },
    xAxis: {
      categories: [],
      type: "category",
      title: {
        text: "Complainant Categories",
      },
    },
    yAxis: {
      title: {
        text: "",
      },
      gridLineWidth: 1,
      gridLineColor: "#e0e0e0",
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
      series: {
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "{point.y}",
          align: "left",
          inside: false,
          x: 5,
          style: {
            textOutline: "none",
            color: "#000000",
            fontWeight: "normal"
          }
        },
        point: {
          events: {
            click: this.onComplaintTypeBarClick.bind(this),
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      useHTML: true,
      formatter: function () {
        return `
         <b>${this.series.name}</b><br>
          <span>${this.key || ""}</span>: ${this.y}
        `;
      },
    },
    series: [
      {
        type: "bar",
        name: "Category",
        data: [],
        colorByPoint: true,
      },
    ],
  };

  chart4Options: Highcharts.Options = {
    chart: {
      type: "bar",
    },
    title: {
      text: "Geographical Data",
      align: "left",
    },
    xAxis: {
      categories: [],
      type: "category",
      title: {
        text: "Complaint Region",
      },
    },
    yAxis: {
      title: {
        text: "",
      },
      gridLineWidth: 1,
      gridLineColor: "#e0e0e0",
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
      series: {
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "{point.y}",
        },
        point: {
          events: {
            click: this.onComplaintDivisionBarClick.bind(this),
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      useHTML: true,
      formatter: function () {
        const regionKey = this.key || "";
        const value = this.y || 0;

        return `
          <b>${this.series.name}</b><br>
          <div style="display: flex; flex-direction: row-reverse;">
            <span style="margin-left: 5px;">${value}  </span> <span style="margin-left:2px;">:</span><span>${regionKey}</span>
          </div>
        `;
      },
    },
    series: [
      {
        type: "bar",
        name: "Region",
        data: [],
        colorByPoint: true,
      },
    ],
  };

  chart: any;
  updateFlag = false;
  updateFlag3 = false;
  updateFlag4 = false;
  chartsFiltered = false;
  private readonly isAsync = true;

  totalCountofComplaintbyStatusChartDataMale: any[] = [];
  totalCountofComplaintbyStatusChartDataFemale: any[] = [];
  totalCountofComplaintbyStatusChartDataOthers: any[] = [];
  totalCountofComplaintbyStatusChartDataCategories: any[] = [];
  totalCountofComplaintbyStatusChartDataTotal: any[] = [];

  totalCountOfComplaintsAppealStatusDataMale: any[] = [];
  totalCountOfComplaintsAppealStatusDataFemale: any[] = [];
  totalCountOfComplaintsAppealStatusDataOthers: any[] = [];
  totalCountOfComplaintsAppealStatusDataCategories: any[] = [];
  totalCountOfComplaintsAppealStatusDataTotal: any[] = [];

  totalCountofComplaintbCategoryChartData: any[] = [];
  totalCountofComplaintbCategoryChartDrillDownData: any[] = [];
  totalCountofComplaintbyCategoryChartDataCategories: any[] = [];

  totalCountofComplaintbyDivisionChartData: any[] = [];
  totalCountofComplaintbyDivisionChartCategories: any[] = [];
  totalCountofComplaintbyDistrictChartData: any[] = [];
  totalCountofComplaintbyDistrictChartCategories: any[] = [];
  totalCountofComplaintbyTehsilChartData: any[] = [];
  totalCountofComplaintbyTehsilChartCategories: any[] = [];

  totalCountofComplaintbyMonthChartData: any[] = [];
  totalCountofComplaintbyMonthChartCategories: any[] = [];

  totalCountOfComplaintsAppealStatus: any[] = [];
  totalCountOfComplaintsByStatusAndGenderData: any[] = [];
  totalCountOfComplaintsByStatusAndGenderDataCategories: any[] = [];

  complaintsByDivision: DashboartChartGenderModel = new DashboartChartGenderModel();
  dataSource: MatTableDataSource<any>;
  drillDown: any[] = [];
  categoryTypeData: any[] = [];
  categoryDrilldownLevel: string = "category";
  currentCategoryDrillValue: string = "Cateory";
  currentDivisionDrillValue: string = "Division";
  currentFilterState: { statusName?: string; genderType?: string } = {};
  selectedComplaintStatus: string = '';
  selectedAppealStatus: string = '';

  // // Dynamic color palette for charts
  chartColorPalette: string[] = [

    '#7C84F5',
    '#4CAF50', // Green  
    '#F44336',  // Red
    '#FFEB3B', // Yellow
    '#2196F3', // Blue

    '#FF9500'
  ];
  // Dynamic color palette for charts
  //chartColorPalette: string[] = 
  // [
  //   '#2F80ED', // Blue
  //   '#27AE60', // Green
  //   '#F2994A', // Orange
  //   '#EB5757', // Red
  //   '#9B51E0', // Purple
  //   '#56CCF2'  // Sky Blue
  // ];

  // [
  //   '#2caffe', // Blue
  //   '#544fc5', // Purple
  //   '#00e272', // Green
  //   '#fe6a35', // Orange
  //   '#6b8abc', // Light Blue
  //   '#d568fb', // Violet
  //   '#2ee0ca', // Teal
  //   '#fa4b42', // Red
  //   '#feb56a', // Peach
  //   '#91e8e1'  // Aqua
  // ];





  // Method to get color by index from palette
  getChartColor(index: number): string {
    return this.chartColorPalette[index % this.chartColorPalette.length];
  }

  options: any;
  userName!: string;

  constructor(
    public elementRef: ElementRef,
    private appDataService: ApplicationDataService,
    private formBuilder: FormBuilder,
    private tokenStorage: TokenStorageService,
    private authService: AuthenticationService,
    private router: Router,
    public dialog: MatDialog
  ) {
    this.dataSource = new MatTableDataSource();
    this.dataSource.sortingDataAccessor = (item, property) => {
      const value = item[property];
      return typeof value === "string" ? value.toLowerCase() : value;
    };
    this.displayedColumns.forEach(
      (column) => (this.selectedColumns[column] = true)
    );
  }

  waitForUserId(): Promise<number> {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        const id = this.tokenStorage.getUserId();
        if (id != null) {
          clearInterval(interval);
          resolve(id);
        }
      }, 50);
    });
  }

  initializeFormAndData(): void {
    this.loadUserid();
    this.getAllUsersData();
    this.form = this.formBuilder.group({
      chartType: ["bar"],
      name: [""],
      division: [{ value: "", disabled: true }],
      district: [{ value: "", disabled: true }],
      tehsil: [{ value: "", disabled: true }],
      complaintType: [{ value: "", disabled: true }],
      complaintSubType: [""],
      dateFrom: [],
      dateTo: [],
      complainantName: [""],
      currentProcessId: [""],
      userId: [""],
      assignTo: [this.assignTo],
      assignToUserName: [this.assignToUserName],
    });
    this.f["assignTo"].disable();
    if (this.userRole === "ADMIN" || this.userRole === "DASHBOARD") {
      this.f["assignTo"].enable();
    }
    this.f["assignTo"].valueChanges.subscribe((value) => {
      const selectedUser = this.usersList.find((user) => user.userId === value);
      if (selectedUser) {
        this.assignToUserName = selectedUser.userName;
        this.f["assignToUserName"].setValue(this.assignToUserName, {
          emitEvent: false,
        });
      }
      this.getData();
    });

    this.f["dateFrom"].valueChanges.subscribe((value: string) => {
      const formattedDate = this.formatDate(new Date(value));
      this.f["dateFrom"].setValue(formattedDate, { emitEvent: false });
      setTimeout(() => this.dateRangeEvent());
    });

    this.f["dateTo"].valueChanges.subscribe((value: string) => {
      const formattedDate = this.formatDate(new Date(value));
      this.f["dateTo"].setValue(formattedDate, { emitEvent: false });
      setTimeout(() => this.dateRangeEvent());
    });

    this.form
      .get("chartType")
      ?.valueChanges.subscribe((chartType: chartType) => {
        this.selectedChartType = chartType;
        this.updateCharts();
      });

    this.getData();
  }

  ngOnInit(): void {
    this.waitForUserId().then((userId) => {
      this.assignTo = userId;
      console.log("assignTo on first render:", this.assignTo);
      this.initializeFormAndData();
    });
    this.loadUserid();
    this.form = this.formBuilder.group({
      chartType: ["bar"],
      name: [""],
      division: [{ value: "", disabled: true }],
      district: [{ value: "", disabled: true }],
      tehsil: [{ value: "", disabled: true }],
      complaintType: [{ value: "", disabled: true }],
      complaintSubType: [""],
      dateFrom: [],
      dateTo: [],
      complainantName: [""],
      currentProcessId: [""],
      userId: [""],
      assignTo: [this.assignTo],
      assignToUserName: [this.assignToUserName],
    });

    this.getAllUsersData();
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  deepCopy(data: any) {
    return JSON.parse(JSON.stringify(data));
  }

  getAllUsersData() {
    this.appDataService.getAllInternalUsers().subscribe({
      next: (res: any) => {
        this.usersListOriginal = Array.isArray(res?.data) ? res.data : [];
        this.usersList = [...this.usersListOriginal];
        // console.log("assingToId", this.assignTo);
        for (let i = 0; i < this.usersList.length; i++) {
          if (this.usersList[i].userId === this.assignTo) {
            this.assignToUserName = this.usersList[i].userName;
            this.assignRole = this.usersList[i].role;
            if (this.assignRole === "ADMIN" || this.assignRole === "DASHBOARD") {
              this.assignRoleAdmin = false;
            } else {
              this.assignRoleAdmin = true;
            }
            // console.log("role value", this.assignRole);
            // console.log("Assign Role Admin", this.assignRoleAdmin);
            this.f["assigneeUserName"]?.setValue(this.assignToUserName);
            break;
          }
        }
        // This request can complete after the dashboard form has been replaced or
        // destroyed during SPA navigation. Do not let that stale subscription
        // break unrelated screens such as the global chatbot.
        this.f["assigneeUserName"]?.disable();
      },
    });
  }

  loadUserid() {
    const permissions = localStorage.getItem("permissions");
    if (permissions) {
      try {
        const parsedPermissions = JSON.parse(permissions);
        this.userRole = parsedPermissions.ROLE;
        this.userId = parsedPermissions.USER;
        const getUserId = parsedPermissions.USER;
        const getUserRole = parsedPermissions.role;
        this.userRole = getUserRole;
        if (getUserId) {
          if (getUserRole === "ADMIN" || getUserRole === "DASHBOARD") {
            this.assignTo = "";
          } else {
            this.assignTo = getUserId;
          }
        }
        // console.log("DATA", parsedPermissions);
      } catch (error) {
        console.error("Error parsing localStorage data:", error);
      }
    }
  }

  onAssigneeSelect(selectedUserId: string) {
    const selectedUser = this.usersList.find(
      (user) => user.userId === selectedUserId
    );
    console.log("in loop");
    if (selectedUser) {
      console.log("safsa", selectedUser);
      this.assignTo = selectedUser.userId;
      this.f["assignTo"].setValue(this.assignTo, { emitEvent: false });

      this.assignToUserName = selectedUser.userName;
      this.f["assignToUserName"].setValue(this.assignToUserName, {
        emitEvent: false,
      });
    } else {
      this.assignTo = "";
    }
  }

  private getData() {
    this.getComplaintsbyStatusCount();
    this.getComplaintsbyCategoryCount();
    this.getDivisionComplaintsCount();
    const complaintsByMonth = this.appDataService.getComplaintsByMonthCount();
  }

  dateRangeEvent(): void {
    let dateFrom = this.f["dateFrom"].value;
    let dateTo = this.f["dateTo"].value;

    dateFrom = this.formatDate(new Date(dateFrom));
    dateTo = this.formatDate(new Date(dateTo));

    console.log("Updated Date Range:", { dateFrom, dateTo });

    if (dateFrom && dateTo) {
      this.getComplaintsbyCategoryCount();
      this.getDivisionComplaintsCount();
      this.getComplaintsbyStatusCount();
    }
  }

  getDivisionComplaintsCount() {
    this.appDataService
      .getComplaintsByStatusAndDivisionCount(this.form.getRawValue())
      .subscribe({
        next: (res: any) => {
          this.handleComplaintsByDivision(res?.data ?? []);
        },
      });
  }

  getComplaintsbyStatusCount() {
    this.chartsFiltered = false;

    this.appDataService
      .getTotalComplaintsByStatusAndGender(this.form.getRawValue())
      .subscribe({
        next: (res: any) => {
          this.handleTotalComplaintsByStatus(res?.data ?? []);
        },
      });
  }

  getComplaintsbyCategoryCount() {
    this.appDataService
      .getTotalComplaintsByCategoryAndSubcategoryCount(this.form.getRawValue())
      .subscribe({
        next: (res: any) => {
          this.categoryTypeData = res?.data ?? [];
          this.handleTotalComplaintsByCategory(this.categoryTypeData);
        },
      });
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  private getDefaultDateFrom(): Date {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
  }

  private handleTotalComplaintsByStatus(data: any[]) {
    this.totalCountofComplaintbyStatusChartDataCategories = [];
    this.totalCountofComplaintbyStatusChartDataMale = [];
    this.totalCountofComplaintbyStatusChartDataFemale = [];
    this.totalCountofComplaintbyStatusChartDataOthers = [];
    this.totalCountofComplaintbyStatusChartDataTotal = [];
    this.totalCountOfComplaintsAppealStatusDataFemale = [];
    this.totalCountOfComplaintsAppealStatusDataMale = [];
    this.totalCountOfComplaintsAppealStatusDataOthers = [];
    this.totalCountOfComplaintsAppealStatusDataCategories = [];
    this.totalCountOfComplaintsAppealStatusDataTotal = [];

    data?.forEach((element: any[]) => {
      if (element[1]?.toLowerCase().includes("appeal")) {
        this.totalCountOfComplaintsAppealStatusDataTotal.push(element[0]);
        this.totalCountOfComplaintsAppealStatusDataMale.push(element[2]);
        this.totalCountOfComplaintsAppealStatusDataFemale.push(element[3]);
        this.totalCountOfComplaintsAppealStatusDataOthers.push(element[4]);
        this.totalCountOfComplaintsAppealStatusDataCategories.push(element[1]);
      } else {
        this.totalCountofComplaintbyStatusChartDataTotal.push(element[0]);
        this.totalCountofComplaintbyStatusChartDataCategories.push(element[1]);
        this.totalCountofComplaintbyStatusChartDataMale.push(element[2]);
        this.totalCountofComplaintbyStatusChartDataFemale.push(element[3]);
        this.totalCountofComplaintbyStatusChartDataOthers.push(element[4]);
      }
    });

    // For chart1 (Complaint Status): always use bar when pie is selected
    const chart1Type = this.selectedChartType === 'pie' ? 'bar' : this.selectedChartType;

    this.chart1Options.series = [
      {
        type: chart1Type,
        name: "Male",
        data: this.totalCountofComplaintbyStatusChartDataMale,
      },
      {
        type: chart1Type,
        name: "Female",
        data: this.totalCountofComplaintbyStatusChartDataFemale,
        color: "#f79bba",
      },
      {
        type: chart1Type,
        name: "Transgender Person",
        data: this.totalCountofComplaintbyStatusChartDataOthers,
      },
    ];

    // For chart2 (Appeal Status): always use bar when pie is selected
    const chart2Type = this.selectedChartType === 'pie' ? 'bar' : this.selectedChartType;

    this.chart2Options.series = [
      {
        type: chart2Type,
        name: "Male",
        data: this.totalCountOfComplaintsAppealStatusDataMale,
      },
      {
        type: chart2Type,
        name: "Female",
        data: this.totalCountOfComplaintsAppealStatusDataFemale,
        color: "#f79bba",
      },
      {
        type: chart2Type,
        name: "Transgender Person",
        data: this.totalCountOfComplaintsAppealStatusDataOthers,
      },
    ];

    // Always set categories for chart1 and chart2 since they're always bar charts when pie is selected
    (this.chart1Options.xAxis as any).categories = this.totalCountofComplaintbyStatusChartDataCategories;
    (this.chart2Options.xAxis as any).categories = this.totalCountOfComplaintsAppealStatusDataCategories;

    this.updateFlag = true;
  }

  private handleTotalComplaintsByCategory(data: any[]) {
    this.totalCountofComplaintbyCategoryChartDataCategories = [];
    this.totalCountofComplaintbCategoryChartData = [];
    this.totalCountofComplaintbCategoryChartDrillDownData = [];

    if (this.f["complaintType"].value != "") {
      let subcategories = this.categoryTypeData.filter(
        (sc) => sc.categoryname === this.f["complaintType"].value
      )[0];
      if (subcategories != null) {
        subcategories?.subcategories?.forEach((element: any) => {
          const data = {
            name: element.subcategoryname,
            y: element.count,
          };
          this.totalCountofComplaintbCategoryChartData.push(data);
          this.totalCountofComplaintbyCategoryChartDataCategories.push(
            element.subcategoryname
          );
        });
        (this.chart3Options.xAxis as any).categories = this.totalCountofComplaintbyCategoryChartDataCategories;

        this.chart3Options.series = [
          {
            type: this.selectedChartType,
            name: this.f["complaintType"].value,
            data: this.totalCountofComplaintbCategoryChartData,
          },
        ];

        this.updateFlag3 = true;
      }
    } else {
      data?.forEach((element: any, index: number) => {
        // Assign colors dynamically from the color palette
        // Use modulo to cycle through colors if there are more categories than colors
        const color = this.chartColorPalette[index % this.chartColorPalette.length];

        const category = {
          name: element?.categoryname,
          y: element?.categorycount,
          color: color // Assign dynamic color from palette
        };
        this.totalCountofComplaintbCategoryChartData.push(category);
        this.totalCountofComplaintbyCategoryChartDataCategories.push(
          element?.categoryname
        );
      });

      (this.chart3Options.xAxis as any).categories = this.totalCountofComplaintbyCategoryChartDataCategories;

      this.chart3Options.series =
        this.selectedChartType === "pie"
          ? [
            {
              type: "pie" as any,
              name: "Category",
              data: this.totalCountofComplaintbCategoryChartData,
              showInLegend: true,
            },
          ]
          : [
            {
              type: "bar" as any,
              name: "Category",
              data: this.totalCountofComplaintbCategoryChartData,
              colorByPoint: true, // Keep colorByPoint for non-pie charts to use our custom colors
            },
          ];
      this.updateFlag3 = true;
    }
  }

  private handleComplaintsByDivision(data: any[]) {
    this.totalCountofComplaintbyDivisionChartData = [];
    this.totalCountofComplaintbyDivisionChartCategories = [];
    this.complaintsByDivision.otherData = [];
    this.complaintsByDivision.categories = [];
    data?.forEach((element: any[]) => {
      const data = {
        name: element[1],
        y: element[0],
      };
      this.totalCountofComplaintbyDivisionChartData.push(data);
      this.totalCountofComplaintbyDivisionChartCategories.push(element[1]);
    });

    (this.chart4Options.xAxis as any).categories = this.totalCountofComplaintbyDivisionChartCategories;

    this.chart4Options.series =
      this.selectedChartType === "pie"
        ? [
          {
            type: this.selectedChartType,
            name: "Division",
            data: this.totalCountofComplaintbyDivisionChartData,
            showInLegend: true,
          },
        ]
        : [
          {
            type: this.selectedChartType,
            name: "Division",
            data: this.totalCountofComplaintbyDivisionChartData,
          },
        ];

    this.updateFlag4 = true;
  }

  private onComplaintDivisionBarClick(column: any) {
    this.currentDivisionDrillValue = column?.point?.name;
    if (column?.point?.name) {
      let exist = this.drillDown.findIndex(
        (d) => d.type == column?.point?.series?.userOptions?.name
      );
      if (exist == -1) {
        this.drillDown.push({
          type: column?.point?.series?.userOptions?.name,
          point: column?.point?.name,
        });
      }
      if (column?.point?.series?.userOptions?.name == "Division") {
        this.getTotalComplaintsByDistictCount(column?.point?.name);
      } else if (column?.point?.series?.userOptions?.name == "District") {
        this.getTotalComplaintsByTehsilCount(column?.point?.name);
      } else if (column?.point?.series?.userOptions?.name == "Tehsil") {
        this.getTotalComplaintsByMouzaCount(column?.point?.name);
      }
    }
  }



  private handleFilteredComplaintsByStatus(data: any[], selectedStatus: string, selectedGender: string) {
    this.totalCountofComplaintbyStatusChartDataCategories = [];
    this.totalCountofComplaintbyStatusChartDataMale = [];
    this.totalCountofComplaintbyStatusChartDataFemale = [];
    this.totalCountofComplaintbyStatusChartDataOthers = [];
    this.totalCountofComplaintbyStatusChartDataTotal = [];

    data?.forEach((element: any[]) => {
      if (!element[1]?.toLowerCase().includes("appeal")) {
        this.totalCountofComplaintbyStatusChartDataTotal.push(element[0]);
        this.totalCountofComplaintbyStatusChartDataCategories.push(element[1]);
        this.totalCountofComplaintbyStatusChartDataMale.push(element[2]);
        this.totalCountofComplaintbyStatusChartDataFemale.push(element[3]);
        this.totalCountofComplaintbyStatusChartDataOthers.push(element[4]);
      }
    });

    // Determine chart type - use bar if pie is selected, otherwise use selected type
    const chartType = this.selectedChartType === 'pie' ? 'bar' : this.selectedChartType;

    this.chart1Options.series = [
      {
        type: chartType,
        name: "Male",
        data: this.totalCountofComplaintbyStatusChartDataMale,
        dataLabels: {
          enabled: true,
          formatter: function () {
            const point = this as any;
            if (point.y && point.y > 0) {
              return point.y;
            }
            return null;
          }
        },
      },
      {
        type: chartType,
        name: "Female",
        data: this.totalCountofComplaintbyStatusChartDataFemale,
        color: "#f79bba",
        dataLabels: {
          enabled: true,
          formatter: function () {
            const point = this as any;
            if (point.y && point.y > 0) {
              return point.y;
            }
            return null;
          }
        },
      },
      {
        type: chartType,
        name: "Transgender Person",
        data: this.totalCountofComplaintbyStatusChartDataOthers,
        dataLabels: {
          enabled: true,
          formatter: function () {
            const point = this as any;
            if (point.y && point.y > 0) {
              return point.y;
            }
            return null;
          }
        },
      },
    ];

    // Set chart type - use bar if pie is selected
    this.chart1Options.chart!.type = chartType;

    (this.chart1Options.xAxis as any).categories = this.totalCountofComplaintbyStatusChartDataCategories;

    this.chart1Options.title = {
      text: "Complaint Status",
      align: "left",
    };

    this.updateFlag = true;
  }

  private onComplaintTypeBarClick(column: any) {
    if (column?.point?.series?.userOptions?.name == "Category") {
      this.f["complaintType"].patchValue(column?.point?.name);
    }
    this.totalCountofComplaintbCategoryChartData = [];
    this.totalCountofComplaintbyCategoryChartDataCategories = [];

    if (this.f["complaintType"].value != "") {
      let subcategories = this.categoryTypeData.filter(
        (sc) => sc.categoryname === this.f["complaintType"].value
      )[0];

      if (subcategories != null) {
        subcategories?.subcategories?.forEach((element: any) => {
          const data = {
            name: element.subcategoryname,
            y: element.count,
          };
          this.totalCountofComplaintbCategoryChartData.push(data);
          this.totalCountofComplaintbyCategoryChartDataCategories.push(
            element.subcategoryname
          );
        });

        this.chart3Options.title = {
          text: "Complaint Category",
          align: "left",
        };

        (this.chart3Options.xAxis as any) = {
          categories: this.totalCountofComplaintbyCategoryChartDataCategories,
          title: { text: "Complaint Category" },
        };

        this.chart3Options.series = [
          {
            type: this.selectedChartType,
            name: this.f["complaintType"].value,
            data: this.totalCountofComplaintbCategoryChartData,
          },
        ];

        this.updateFlag3 = true;
      }
    }

    if (this.f["division"].value == "") {
      this.getDivisionComplaintsCount();
    } else if (this.f["district"].value == "") {
      this.getTotalComplaintsByDistictCount(this.f["division"].value);
    } else if (this.f["tehsil"].value == "") {
      this.getTotalComplaintsByTehsilCount(this.f["district"].value);
    } else if (this.f["mouza"].value == "") {
      this.getTotalComplaintsByMouzaCount(this.f["tehsil"].value);
    }

    this.updateStatusChartsBasedOnCurrentState();
  }

  drillback(column: any) {
    if (column?.type) {
      if (column?.type == "Division") {
        this.drillDown = [];
        this.f["division"].patchValue("");
        this.f["district"].patchValue("");
        this.f["tehsil"].patchValue("");
        this.getDivisionComplaintsCount();
        this.getComplaintsbyCategoryCount();
        this.updateStatusChartsBasedOnCurrentState();
      } else if (column?.type == "District") {
        this.f["district"].patchValue("");
        this.f["tehsil"].patchValue("");
        this.getTotalComplaintsByDistictCount(this.drillDown.at(0).point);
        this.drillDown.splice(1);
      } else if (column?.type == "Tehsil") {
        this.f["tehsil"].patchValue("");
        this.getTotalComplaintsByTehsilCount(this.drillDown.at(1).point);
        this.drillDown.splice(2);
      }
    }
  }

  private getTotalComplaintsByDistictCount(name: any) {
    this.f["name"].patchValue(name);
    this.f["division"].patchValue(name);
    this.totalCountofComplaintbyDivisionChartData = [];
    this.totalCountofComplaintbyDivisionChartCategories = [];
    this.appDataService
      .getTotalComplaintsByDistictCount(this.form.getRawValue())
      .subscribe((response: any) => {
        if (response?.data?.length) {
          response?.data?.forEach((element: any[]) => {
            const data = {
              name: element[1],
              y: element[0],
            };
            this.totalCountofComplaintbyDivisionChartData.push(data);
            this.totalCountofComplaintbyDivisionChartCategories.push(
              element[1]
            );
          });
          (this.chart4Options.xAxis as any).categories = this.totalCountofComplaintbyDivisionChartCategories;

          this.chart4Options.series = [
            {
              type: this.selectedChartType,
              name: "District",
              data: this.totalCountofComplaintbyDivisionChartData,
            },
          ];

          this.updateFlag4 = true;
        }
      });

    this.getComplaintsbyCategoryCount();
    this.updateStatusChartsBasedOnCurrentState();
  }

  private getTotalComplaintsByTehsilCount(name: any) {
    this.f["name"].patchValue(name);
    this.f["district"].patchValue(name);
    this.totalCountofComplaintbyDivisionChartData = [];
    this.totalCountofComplaintbyDivisionChartCategories = [];
    this.appDataService
      .getTotalComplaintsByTehsilCount(this.form.getRawValue())
      .subscribe((response: any) => {
        if (response?.data?.length) {
          response?.data?.forEach((element: any[]) => {
            const data = {
              name: element[1],
              y: element[0],
            };
            this.totalCountofComplaintbyDivisionChartData.push(data);
            this.totalCountofComplaintbyDivisionChartCategories.push(
              element[1]
            );
          });
          (this.chart4Options.xAxis as any).categories = this.totalCountofComplaintbyDivisionChartCategories;
          this.chart4Options.series = [
            {
              type: this.selectedChartType,
              name: "Tehsil",
              data: this.totalCountofComplaintbyDivisionChartData,
            },
          ];

          this.updateFlag4 = true;
        }
      });
    this.getComplaintsbyCategoryCount();
    this.updateStatusChartsBasedOnCurrentState();
  }

  private getTotalComplaintsByMouzaCount(name: any) {
    this.f["name"].patchValue(name);
    this.f["tehsil"].patchValue(name);
    this.totalCountofComplaintbyDivisionChartData = [];
    this.totalCountofComplaintbyDivisionChartCategories = [];
    this.appDataService
      .getTotalComplaintsByMouzaCount(this.form.getRawValue())
      .subscribe((response: any) => {
        if (response?.data?.length) {
          response?.data?.forEach((element: any[]) => {
            const data = {
              name: element[1],
              y: element[0],
            };
            this.totalCountofComplaintbyDivisionChartData.push(data);
            this.totalCountofComplaintbyDivisionChartCategories.push(
              element[1]
            );
          });
          (this.chart4Options.xAxis as any).categories = this.totalCountofComplaintbyDivisionChartCategories;

          this.chart4Options.series = [
            {
              type: this.selectedChartType,
              name: "Mouza",
              data: this.totalCountofComplaintbyDivisionChartData,
            },
          ];

          this.updateFlag4 = true;
        }
      });

    this.getComplaintsbyCategoryCount();
    this.updateStatusChartsBasedOnCurrentState();
  }

  goBackToCategories() {
    this.f["complaintType"].patchValue("");

    this.chart3Options.title = {
      text: "Complainant Categories",
      align: "left",
    };

    (this.chart3Options.xAxis as any) = {
      categories: [],
      type: "category",
      title: {
        text: "Complainant Categories",
      },
    };

    this.getComplaintsbyCategoryCount();
    this.getDivisionComplaintsCount();
    this.updateStatusChartsBasedOnCurrentState();
  }

  resetComplaintStatusChart() {
    this.chartsFiltered = false;
    this.currentFilterState = {};
    this.selectedComplaintStatus = '';
    this.selectedAppealStatus = '';

    this.chart1Options.title = {
      text: "Complaint Status",
      align: "left",
    };

    this.chart2Options.title = {
      text: "Appeal Status",
      align: "left",
    };

    this.getComplaintsbyStatusCount();
  }

  private onComplaintStatusBarClick(column: any) {
    if (this.chartsFiltered) return; // Prevent clicks when filtered

    const statusName = column?.point?.category || column?.point?.name;
    const genderType = column?.point?.series?.name;

    if (statusName && genderType) {
      this.selectedComplaintStatus = statusName;
      this.selectedAppealStatus = 'Total Appeal Complaints'; // Always set this for appeal chart
      this.updateBothChartsWithFilter(statusName, genderType);
    }
  }

  private onAppealStatusBarClick(column: any) {
    if (this.chartsFiltered) return; // Prevent clicks when filtered

    const statusName = column?.point?.category || column?.point?.name;
    const genderType = column?.point?.series?.name;

    if (statusName && genderType) {
      this.selectedAppealStatus = 'Total Appeal Complaints'; // Always set this for appeal chart
      this.selectedComplaintStatus = statusName; // Set the clicked status for complaint chart
      this.updateBothChartsWithFilter(statusName, genderType);
    }
  }

  private updateBothChartsWithFilter(statusName: string, genderType: string) {
    this.currentFilterState = { statusName, genderType };

    const filterData = {
      ...this.form.getRawValue(),
      status: statusName,
      gender: genderType
    };

    this.appDataService.getComplaintsByStatusAndGender(filterData).subscribe({
      next: (res: any) => {
        this.chartsFiltered = true;
        this.handleFilteredComplaintsByStatus(res?.data ?? [], statusName, genderType);
        this.handleFilteredAppealsByStatus(res?.data ?? [], statusName, genderType);
      },
      error: (error: any) => {
        console.error('Error fetching data by status and gender:', error);
      }
    });
  }

  private handleFilteredAppealsByStatus(data: any[], selectedStatus: string, selectedGender: string) {
    this.totalCountOfComplaintsAppealStatusDataCategories = [];
    this.totalCountOfComplaintsAppealStatusDataMale = [];
    this.totalCountOfComplaintsAppealStatusDataFemale = [];
    this.totalCountOfComplaintsAppealStatusDataOthers = [];
    this.totalCountOfComplaintsAppealStatusDataTotal = [];

    data?.forEach((element: any[]) => {
      if (element[1]?.toLowerCase().includes("appeal")) {
        this.totalCountOfComplaintsAppealStatusDataTotal.push(element[0]);
        this.totalCountOfComplaintsAppealStatusDataCategories.push(element[1]);
        this.totalCountOfComplaintsAppealStatusDataMale.push(element[2]);
        this.totalCountOfComplaintsAppealStatusDataFemale.push(element[3]);
        this.totalCountOfComplaintsAppealStatusDataOthers.push(element[4]);
      }
    });

    // Determine chart type - use bar if pie is selected, otherwise use selected type
    const chartType = this.selectedChartType === 'pie' ? 'bar' : this.selectedChartType;

    this.chart2Options.series = [
      {
        type: chartType,
        name: "Male",
        data: this.totalCountOfComplaintsAppealStatusDataMale,
        dataLabels: {
          enabled: true,
          formatter: function () {
            const point = this as any;
            if (point.y && point.y > 0) {
              return point.y;
            }
            return null;
          }
        },
      },
      {
        type: chartType,
        name: "Female",
        data: this.totalCountOfComplaintsAppealStatusDataFemale,
        color: "#f79bba",
        dataLabels: {
          enabled: true,
          formatter: function () {
            const point = this as any;
            if (point.y && point.y > 0) {
              return point.y;
            }
            return null;
          }
        },
      },
      {
        type: chartType,
        name: "Transgender Person",
        data: this.totalCountOfComplaintsAppealStatusDataOthers,
        dataLabels: {
          enabled: true,
          formatter: function () {
            const point = this as any;
            if (point.y && point.y > 0) {
              return point.y;
            }
            return null;
          }
        },
      },
    ];

    // Set chart type - use bar if pie is selected
    this.chart2Options.chart!.type = chartType;
    (this.chart2Options.xAxis as any).categories = this.totalCountOfComplaintsAppealStatusDataCategories;

    this.chart2Options.title = {
      text: `Appeal Status - ${selectedStatus}`,
      align: "left",
    };
    this.updateFlag = true;
  }



  private updateStatusChartsBasedOnCurrentState() {
    if (this.chartsFiltered && this.currentFilterState.statusName && this.currentFilterState.genderType) {
      this.updateBothChartsWithFilter(this.currentFilterState.statusName, this.currentFilterState.genderType);
    } else {
      this.getComplaintsbyStatusCount();
    }
  }

  resetAppealStatusChart() {
    this.chartsFiltered = false;
    this.currentFilterState = {};
    this.selectedComplaintStatus = '';
    this.selectedAppealStatus = '';

    this.chart1Options.title = {
      text: "Complaint Status",
      align: "left",
    };

    this.chart2Options.title = {
      text: "Appeal Status",
      align: "left",
    };

    this.getComplaintsbyStatusCount();
  }
}
